export const EXCLUSIVE_PAYMENT_PROVIDER_MESSAGE =
  'Only one payment provider can be enabled at a time'
